import { createFileRoute } from "@tanstack/react-router";

import { ProfileContainer } from "@/features/settings/containers/profile-container";

export const Route = createFileRoute("/settings/profile")({
  component: ProfileContainer,
});
